var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7499 57.1624V43.5549L62.0149 31.9124L57.9849 25.5874L39.9999 37.0549L27.2899 28.9499L41.8374 20.7674L38.1624 14.2324L18.1624 25.4824L19.9999 28.7499L17.9849 31.9124L36.2499 43.5549V57.1624L22.0149 48.0874L17.9849 54.4124L37.9849 67.1624L39.9999 63.9999L42.0149 67.1624L62.0149 54.4124L57.9849 48.0874L43.7499 57.1624Z",
    fill: "#38383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22.5C42.7614 22.5 45 20.2614 45 17.5C45 14.7386 42.7614 12.5 40 12.5C37.2386 12.5 35 14.7386 35 17.5C35 20.2614 37.2386 22.5 40 22.5Z",
    fill: "#9AFF42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33.75C62.7614 33.75 65 31.5114 65 28.75C65 25.9886 62.7614 23.75 60 23.75C57.2386 23.75 55 25.9886 55 28.75C55 31.5114 57.2386 33.75 60 33.75Z",
    fill: "#9AFF42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.75C22.7614 33.75 25 31.5114 25 28.75C25 25.9886 22.7614 23.75 20 23.75C17.2386 23.75 15 25.9886 15 28.75C15 31.5114 17.2386 33.75 20 33.75Z",
    fill: "#9AFF42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67.5C42.7614 67.5 45 65.2614 45 62.5C45 59.7386 42.7614 57.5 40 57.5C37.2386 57.5 35 59.7386 35 62.5C35 65.2614 37.2386 67.5 40 67.5Z",
    fill: "#9AFF42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 56.25C22.7614 56.25 25 54.0114 25 51.25C25 48.4886 22.7614 46.25 20 46.25C17.2386 46.25 15 48.4886 15 51.25C15 54.0114 17.2386 56.25 20 56.25Z",
    fill: "#9AFF42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56.25C62.7614 56.25 65 54.0114 65 51.25C65 48.4886 62.7614 46.25 60 46.25C57.2386 46.25 55 48.4886 55 51.25C55 54.0114 57.2386 56.25 60 56.25Z",
    fill: "#9AFF42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45C42.7614 45 45 42.7614 45 40C45 37.2386 42.7614 35 40 35C37.2386 35 35 37.2386 35 40C35 42.7614 37.2386 45 40 45Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon2);
export default __webpack_public_path__ + "static/media/svc_icon2.8315bf52f5c6f2da8f9a12e9c58aa503.svg";
export { ForwardRef as ReactComponent };